import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Tasks from "@/pages/Tasks";
import Decisions from "@/pages/Decisions";
import Risks from "@/pages/Risks";
import Episodes from "@/pages/Episodes";
import Guests from "@/pages/Guests";
import Sponsors from "@/pages/Sponsors";
import Relay from "@/pages/Relay";
import PublicRelay from "@/pages/PublicRelay";
import Rules from "@/pages/Rules";
import Voice from "@/pages/Voice";
import IntakeLab from "@/pages/IntakeLab";
import Layout from "@/components/Layout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="h-screen flex items-center justify-center text-[color:var(--oz-text-dim)]">Initializing operating system…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/c/:threadId" element={<PublicRelay />} />
        <Route path="/" element={<Protected><Dashboard /></Protected>} />
        <Route path="/tasks" element={<Protected><Tasks /></Protected>} />
        <Route path="/decisions" element={<Protected><Decisions /></Protected>} />
        <Route path="/risks" element={<Protected><Risks /></Protected>} />
        <Route path="/episodes" element={<Protected><Episodes /></Protected>} />
        <Route path="/guests" element={<Protected><Guests /></Protected>} />
        <Route path="/sponsors" element={<Protected><Sponsors /></Protected>} />
        <Route path="/relay" element={<Protected><Relay /></Protected>} />
        <Route path="/relay/:threadId" element={<Protected><Relay /></Protected>} />
        <Route path="/rules" element={<Protected><Rules /></Protected>} />
        <Route path="/voice" element={<Protected><Voice /></Protected>} />
        <Route path="/intake-lab" element={<Protected><IntakeLab /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
